import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TimeRange } from '../../models/trend-live-models/TimeRange';

/**
 * Generated class for the TimePickerComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'time-picker',
  templateUrl: 'time-picker.html'
})
export class TimePickerComponent {

  text: string;
  selectedButton = "1Y";
  timeRanges: TimeRange[] = [new TimeRange(1, "Y", false)];

  @Output() onTimeChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() displayedValues?: any = [
    { value: 1, type: "h" },
    { value: 6, type: "h" },
    { value: 1, type: "d" },
    { value: 1, type: "w" },
    { value: 1, type: "M" },
    { value: 3, type: "M" },
    { value: 1, type: "Y" },
  ];

  constructor() {
  }

  resetZoom() {
    this.selectedButton = 1 + "Y";
    this.onTimeChange.emit(new TimeRange(1, "Y", false))
  }

  updateTime(value, type) {
    this.selectedButton = value + type;
    this.onTimeChange.emit(new TimeRange(value, type, false))
  }
}



// WEBPACK FOOTER //
// ./src/components/time-picker/time-picker.ts